<ng-container *ngLet="breakPointObserve$ | async">
  <ng-container *ngIf="screenRes === 0 && !isImpairedVersion">
    <button
      [disabled]="disable"
      [ngClass]="{ 'button-open': !darkStyle && menuOpen ,'btn-secondary': !darkStyle,'btn-primary': darkStyle,darkStyleHover: menuOpen && darkStyle}"
      class="btn-with-icon  small download-button"
      [matMenuTriggerFor]="menu"
      #menuTrigger="matMenuTrigger"
      (click)="buttonDownloadClick($event)"
    >
      <span class="text"> {{ 'DATA.TABLE.EXPORT' | translate }} </span>
      <svg [icon]="menuOpen ? icons.ArrowDropUp : icons.ArrowDropDown" class="svg24" />
    </button>
    <mat-menu #menu="matMenu">
      <div class="body mt12">
        <ng-container *ngIf="isDynamic; then dynamicCatalog; else staticCatalog"></ng-container>
      </div>
    </mat-menu>
  </ng-container>
  <ng-container *ngIf="screenRes !== 0 && !isImpairedVersion">
    <button class="btn-empty" (click)="openModal()">
      <svg [icon]="icons.MoreVert" class="svg24 dark-gray-color" />
    </button>
  </ng-container>
  <ng-container *ngIf="isImpairedVersion">

    <div
      class="btn-empty"
      [matMenuTriggerFor]="menu"
      #menuTrigger="matMenuTrigger"
    >
      <ng-content></ng-content>
    </div>
    <mat-menu #menu="matMenu" class="cdk-version-for-visually-impaired">
      <div class="body-impaired">
        <ng-container *ngIf="isDynamic; then dynamicCatalogImpaired; else staticCatalogImpaired"></ng-container>
      </div>
    </mat-menu>
  </ng-container>
</ng-container>

<ng-template #staticCatalog>
  <span class="overline-2 inactive-color">{{ 'DATA.DOWNLOAD.EXPORT_DATA_SET' | translate }}</span>
  <button (click)="downloadFile($event, file)" *ngFor="let file of filesTypes" class="btn-empty btn-with-icon" mat-menu-item>
    <svg [ngClass]="{'loading-icon': file.idFile && file.status === 'PROCESSING'}" [icon]=" !file.idFile ? icons.AddPlus : file.idFile && file.status === 'PROCESSING' ? icons.Loading : icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h3 mr4 file-format"> {{ file.format }} </span>
    <span *ngIf="file.idFile && (file.status === 'SUCCESS' || file.status === 'ARCHIVE')" class="body-1"> ({{'OTHER.ARCH' | translate}} zip: {{ file.archiveFileSize + ' kb' }}) </span>
  </button>

  <button [routerLink]="'/developers/useApi'" [queryParams]="{geoJson: catalogId}" class="btn-empty btn-with-icon" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h3 mr4"> geojson </span>
    <span class="body-1"> ({{ 'DATA.DOWNLOAD.ONLY_AVAILABLE_VIA_API' | translate }}) </span>
  </button>

  <ng-container *ngTemplateOutlet="passport"></ng-container>
</ng-template>

<ng-template #dynamicCatalog>
  <button
    matTooltip="{{ 'DATA.DOWNLOAD_HISTORICAL_DATA_TOOLTIP' | translate }}"
    (click)="openHistoricalDataModal()"
    class="btn-empty btn-with-icon"
    mat-menu-item
  >
    <svg [icon]="icons.Downloaded" class="svg24 mr12" />
    <span class="body-1"> {{ 'DATA.DOWNLOAD_HISTORICAL_DATA' | translate }} </span>
  </button>

  <ng-container *ngTemplateOutlet="passport"></ng-container>
</ng-template>

<ng-template #passport>
  <div class="mt12">
    <span class="overline-2 inactive-color">{{ 'DATA.DOWNLOAD.EXPORT_PASSPORT' | translate }}</span>
  </div>
  <button (click)="downloadPasport('json')" class="btn-empty btn-with-icon" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h3"> json </span>
  </button>

  <button (click)="downloadPasport('csv')" class="btn-empty btn-with-icon" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg24 mr12 dark-gray-color" />
    <span class="h3"> csv </span>
  </button>
</ng-template>


<ng-template #staticCatalogImpaired>
  <div class="button1-impaired-text">{{ 'DATA.DOWNLOAD.EXPORT_DATA_SET' | translate }}</div>
  <button (click)="downloadFile($event, file)" *ngFor="let file of filesTypes" class="btn-empty btn-with-icon btn-impaired" mat-menu-item>
    <svg [ngClass]="{'loading-icon': file.idFile && file.status === 'PROCESSING'}" [icon]=" !file.idFile ? icons.AddPlus : file.idFile && file.status === 'PROCESSING' ? icons.Loading : icons.Downloaded" class="svg32 mr12 impaired-color" />
    <span class="mr4 h3-impaired"> {{ file.format }} </span>
    <span *ngIf="file.idFile && (file.status === 'SUCCESS' || file.status === 'ARCHIVE')" class="h3-impaired"> ({{'OTHER.ARCH' | translate}} zip: {{ file.archiveFileSize + ' kb' }}) </span>
  </button>

  <button [routerLink]="'/developers/useApi'" [queryParams]="{geoJson: catalogId}" class="btn-empty btn-with-icon btn-impaired" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg32 mr12 impaired-color" />
    <span class="mr4 h3-impaired"> geojson </span>
    <span class="h3-impaired"> ({{ 'DATA.DOWNLOAD.ONLY_AVAILABLE_VIA_API' | translate }}) </span>
  </button>

  <ng-container *ngTemplateOutlet="passportImpaired"></ng-container>
</ng-template>

<ng-template #dynamicCatalogImpaired>
  <button
    matTooltip="{{ 'DATA.DOWNLOAD_HISTORICAL_DATA_TOOLTIP' | translate }}"
    (click)="openHistoricalDataModal()"
    class="btn-empty btn-with-icon btn-impaired"
    mat-menu-item
  >
    <svg [icon]="icons.Downloaded" class="svg32 mr12" />
    <span class="h3-impaired"> {{ 'DATA.DOWNLOAD_HISTORICAL_DATA' | translate }} </span>
  </button>

  <ng-container *ngTemplateOutlet="passportImpaired"></ng-container>
</ng-template>

<ng-template #passportImpaired>
  <div class="mt12">
    <div class="button1-impaired-text">{{ 'DATA.DOWNLOAD.EXPORT_PASSPORT' | translate }}</div>
  </div>
  <button (click)="downloadPasport('json')" class="btn-empty btn-with-icon btn-impaired" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg32 mr12 impaired-color" />
    <span class="h3-impaired"> json </span>
  </button>

  <button (click)="downloadPasport('csv')" class="btn-empty btn-with-icon btn-impaired" mat-menu-item>
    <svg [icon]="icons.Downloaded" class="svg32 mr12 impaired-color" />
    <span class="h3-impaired"> csv </span>
  </button>
</ng-template>

